import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProviderRatingComponent } from './provider-rating.component';

const routes: Routes = [
  {
    path: '',component: ProviderRatingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProviderRatingRoutingModule { }
